// extracted by mini-css-extract-plugin
export var back = "modal-module--back--645e0";
export var backReturn = "modal-module--backReturn--53dc9";
export var close = "modal-module--close--9c6de";
export var closeNotFull = "modal-module--closeNotFull--aa065";
export var fullScreenModal = "modal-module--fullScreenModal--9dfed";
export var icon = "modal-module--icon--ae8ef";
export var modal = "modal-module--modal--0db4e";
export var open = "modal-module--open--3cdf5";
export var wrapper = "modal-module--wrapper--89b86";